module.exports = {
  REVIEW: 'REVIEW',
  SUMMARY: 'SUMMARY',
};
